import { publisherService } from '@/services/api'
import { groupByArrayOfObject } from '@/common/arrays'
import { StoreUserRelationStatus } from '@/constants'

const initialStates = {
    status: 'LOADING',
    publishersList: {},
    pagination: {
        no_paginate: false,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    params: {
        page: 1
    }
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setPublishersList(state, publishers) {
        state.status = 'SET_LIST'
        state.publishersList = Object.assign({}, state.publishers, publishers)
    },
    setSinglePublisher(state, publisher) {
        state.status = 'SET_SINGLE'
        state.publishersList[publisher.id] = Object.assign({}, publisher, {
            fetch_find: true,
        })
    },
    setPagination(state, pagination) {
        state.status = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    resetParams(state) {
        state.status = 'RESET_PARAMS'
        state.params = {
            page: 1
        }
    },
    updatePublisher(state, publisher) {
        state.status = 'UPDATE_PUBLISHER'
        state.publishersList[publisher.id] = Object.assign({}, state.publishersList[publisher.id], publisher)
    },
    error(state) {
        state.status = 'ERROR'
    },
}

const getters = {
    status: state   => state.status,
    publishers: state => state.publishersList,
    publishersCount: state => Object.keys(state.publishersList).length,
    publisherById: state => id => state.publishersList[id],
    params: state => state.params,
    pagination: state => state.pagination,
    selectablePublishers: (state, getters) => {
        return Object.keys(getters.publishers).map((id) => {
            return {
                value: getters.publishers[id].publisher_id,
                label: getters.publishers[id].full_name,
            }
        })
    }
}

const actions = {
    setParamsAndFetch({dispatch}, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({commit}, params) {
        commit('setParams', params)
    },
    resetParams({commit}) {
        commit('resetParams')
    },
    fetch({commit, state}, params) {
        params = Object.assign({}, state.params, params)

        commit('loading')

        return new Promise((resolve, reject) => {
            publisherService.fetch(params)
                .then(response => {
                    const result = response.data
                    const publishers = groupByArrayOfObject(result.data, 'id')

                    commit('setPublishersList', publishers)
                    if (params.no_paginate) {
                        commit('setPagination', {
                            no_paginate: true
                        })
                    } else {
                        commit('setPagination', {
                            per_page: result.per_page,
                            current_page: result.current_page,
                            last_page: result.last_page,
                            no_paginate: false,
                        })
                        commit('setParams', {
                            page: result.current_page,
                        })
                    }
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    findByRelId({commit, state}, params) {
        params = Object.assign({}, state.params, params)

        commit('loading')

        return new Promise((resolve, reject) => {
            publisherService.findByRelId(params.rel_id)
                .then(response => {
                    const result = response.data
                    const publisher = result.data

                    commit('setSinglePublisher', publisher)
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    changeStatus({commit}, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            publisherService.changeStatus(params.user_id, params.store_id, {
                status: params.status,
                stop_working_result: params.stop_working_result
            })
                .then(() => {
                    commit('updatePublisher', {
                        id: params.id,
                        updated_at: new Date,
                        status: params.status,
                        accepted_at: params.status === StoreUserRelationStatus.ACTIVE ? new Date : null,
                        stop_working_result: params.stop_working_result,
                    })
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    changeGroup({commit}, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            publisherService.changeGroup(params.user_id, params.store_id, {group_id: params.group_id})
                .then(() => {
                    commit('updatePublisher', {
                        updated_at: new Date,
                        group_id: params.group_id,
                        id: params.user_id
                    })
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}